
import { cookieNames, cookieDayLength } from '@/constants'
import { saveCookie, getCookie } from './cookie'

export function getLocationPreference (type) {
  return getCookie(`${cookieNames.location}-${type}`)
}

export function setLocationPreferenceBoundingBox (type, mapBoxSelection) {
  setLocationPreference(type)
  saveCookie(`${cookieNames.location}-${type}`, JSON.stringify(mapBoxSelection), cookieDayLength)
}

export function setLocationPreference (type) {
  saveCookie(cookieNames.preference, type, cookieDayLength)
}

export function getLastLocationPreference () {
  return getCookie(`${cookieNames.location}-${getCookie(cookieNames.preference)}`)
}
